import React from 'react';

export default React.createContext({
  setUser: () => {},
  user: null,
});
